"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RadioButton_styled_exports = {};
__export(RadioButton_styled_exports, {
  StyledInput: () => StyledInput,
  StyledLabel: () => StyledLabel,
  StyledRadio: () => StyledRadio,
  StyledRadioBtn: () => StyledRadioBtn,
  StyledSpan: () => StyledSpan
});
module.exports = __toCommonJS(RadioButton_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_baseTheme = __toESM(require("../../../themes/baseTheme"));
var beigeBorder = function beigeBorder2() {
  return (0, import_styled_components.css)(["border:1px solid ", ";"], import_baseTheme.default.colors.beige[180]);
};
var StyledRadio = import_styled_components.default.div.withConfig({
  displayName: "RadioButtonstyled__StyledRadio",
  componentId: "sc-bi185y-0"
})(function(_ref) {
  var theme = _ref.theme, disabled = _ref.disabled, darkMode = _ref.darkMode;
  var backgroundColor = function backgroundColor2() {
    if (disabled) {
      return "background-color: none";
    }
    return darkMode ? "background-color: ".concat(theme.colors.beige[120], ";") : "background-color: ".concat(theme.colors.pr[180], ";");
  };
  return (0, import_styled_components.css)(["position:relative;display:inline-flex;align-items:center;.radio-radio:after{content:'';width:100%;height:100%;display:block;border-radius:50%;background-color:", ";transform:scale(0);transition:transform 0.15s;}input:checked:hover{+ .radio-radio:after{background-color:", ";}}input:checked + .radio-radio:after{transform:scale(1);}input:checked:active + .radio-radio:after{", ":hover{", "}}input:checked:hover{+ .radio-radio{border:", ";:active{border:1px solid ", ";}:active:after{", "}}}input:checked:active{+ .radio-radio{border:", ";}}input:focus{box-shadow:", ";outline:none;}input:checked:active + .radio-radio,input:not(checked):active + .radio-radio,input:focus-visible{outline:none;box-shadow:none;}input:focus-visible{+ .radio-radio{", " box-shadow:", ";outline:none;}}input:focus-visible:hover{+ .radio-radio{", "}}"], disabled ? theme.colors.n[40] : darkMode ? theme.colors.white : theme.colors.pr.base, disabled ? theme.colors.n[40] : darkMode ? theme.colors.beige[60] : theme.colors.pr.base, backgroundColor(), backgroundColor(), darkMode ? "1px solid ".concat(theme.colors.beige[180]) : "1px solid ".concat(import_baseTheme.default.colors.black), import_baseTheme.default.colors.black, backgroundColor(), darkMode ? "1px solid ".concat(theme.colors.beige[160], ";") : "1px solid ".concat(import_baseTheme.default.colors.black, ";"), darkMode ? "".concat(theme.measurements.shadows.extraSmall, " ").concat(theme.colors.black, ", ").concat(theme.measurements.shadows.small, " ").concat(theme.colors.beige[160]) : "".concat(theme.measurements.shadows.extraSmall, " ").concat(theme.colors.white, ", ").concat(theme.measurements.shadows.small, " ").concat(theme.colors.beige[180]), beigeBorder(), darkMode ? "".concat(theme.measurements.shadows.extraSmall, " ").concat(theme.colors.black, ", ").concat(theme.measurements.shadows.small, " ").concat(theme.colors.beige[180]) : "".concat(theme.measurements.shadows.extraSmall, " ").concat(theme.colors.white, ", ").concat(theme.measurements.shadows.small, " ").concat(theme.colors.beige[180]), beigeBorder());
});
var StyledLabel = import_styled_components.default.label.withConfig({
  displayName: "RadioButtonstyled__StyledLabel",
  componentId: "sc-bi185y-1"
})(function(_ref2) {
  var theme = _ref2.theme, disabled = _ref2.disabled, darkMode = _ref2.darkMode;
  return (0, import_styled_components.css)(["font-size:", ";font-family:", ";font-weight:", ";color:", ";align-items:center;margin-left:12px;cursor:", ";"], theme.typography.sizes.medium, theme.typography.fonts.primary, theme.typography.weights.regular, darkMode ? disabled ? theme.colors.n[30] : theme.colors.white : disabled ? theme.colors.n[60] : theme.colors.black, disabled ? "default" : "pointer");
});
var StyledInput = import_styled_components.default.input.withConfig({
  displayName: "RadioButtonstyled__StyledInput",
  componentId: "sc-bi185y-2"
})(function(_ref3) {
  var theme = _ref3.theme, disabled = _ref3.disabled, darkMode = _ref3.darkMode;
  var getRadioColor = function getRadioColor2() {
    return disabled ? beigeBorder() : darkMode ? "border: 2px solid ".concat(theme.colors.white) : "border: 2px solid ".concat(theme.colors.black);
  };
  return (0, import_styled_components.css)(["width:100%;height:100%;box-sizing:border-box;position:absolute;opacity:0;margin:auto;z-index:1;cursor:", ";:hover:not(:checked){+ .radio-radio{", ";}}:active:not(:checked){+ .radio-radio{background-color:", ";border:", ";}}"], disabled ? "not-allowed" : "default", getRadioColor(), disabled ? theme.colors.white : darkMode ? theme.colors.n[80] : theme.colors.beige[40], darkMode ? "1px solid ".concat(import_baseTheme.default.colors.beige[160]) : "1px solid ".concat(import_baseTheme.default.colors.beige[180]));
});
var StyledSpan = import_styled_components.default.span.withConfig({
  displayName: "RadioButtonstyled__StyledSpan",
  componentId: "sc-bi185y-3"
})(function(_ref4) {
  var theme = _ref4.theme, disabled = _ref4.disabled, isSelected = _ref4.isSelected;
  var spanCrossed = function spanCrossed2() {
    return (0, import_styled_components.css)(["width:15px;background:", ";height:1px;transform:rotate(-45deg);"], theme.colors.beige[180]);
  };
  return (0, import_styled_components.css)(["content:'';position:absolute;", ""], disabled && !isSelected ? spanCrossed() : null);
});
var StyledRadioBtn = import_styled_components.default.div.withConfig({
  displayName: "RadioButtonstyled__StyledRadioBtn",
  componentId: "sc-bi185y-4"
})(function(_ref5) {
  var disabled = _ref5.disabled, darkMode = _ref5.darkMode;
  return (0, import_styled_components.css)(["width:1rem;height:1rem;border-radius:50%;box-sizing:border-box;padding:1px;cursor:", ";", ":active{border:1px solid ", ";}"], disabled ? "default" : "pointer", disabled ? "border: 1px solid ".concat(import_baseTheme.default.colors.n[30], ";") : darkMode ? "border: 1px solid ".concat(import_baseTheme.default.colors.beige[160], ";") : "border: 1px solid ".concat(import_baseTheme.default.colors.beige[180], ";"), import_baseTheme.default.colors.black);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledInput,
  StyledLabel,
  StyledRadio,
  StyledRadioBtn,
  StyledSpan
});
//# sourceMappingURL=RadioButton.styled.js.map